import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { initTheme } from "./components/ui/ThemeToggle";
import "./index.css";

// Apply persisted theme (or OS preference) before the first paint so
// users don't see a light-mode flash if they prefer dark.
initTheme();

// Single QueryClient for the SPA lifetime. Receipt lists get a short
// staleTime so paging feels instant; the user-session query is long-
// lived (the server invalidates it on 401, the SPA reloads /me).
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename="/panel">
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}
